import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Box, Button, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import { useInputState } from 'lib/useInputState';

const PREFIX = 'ViewBillCheckoutNoteDialog';

const classes = {
    title: `${PREFIX}title`
};

const StyledBox = styled(Box)(({ theme }) => ({
    width: '100%',
    overflow: 'hidden',
    [`& .${classes.title}`]: {
        textAlign: 'center',
        width: '100%',
        fontFamily: `TenantFont, ${theme.typography.fontFamily}`,
        fontWeight: 'bold',
        color: theme.palette.titleTextColour
    }
}));

interface ViewBillCheckoutNoteDialogProps {
    title: string;
    description: string;
    initialValue?: string;
    onChange: (title: string, value: string) => void;
}

export const ViewBillCheckoutNoteDialog: React.FC<React.PropsWithChildren<ViewBillCheckoutNoteDialogProps>> =
    ({ title, onChange, initialValue, description }) => {
        const { t } = useTranslation();
        const [value, handleChange] = useInputState(initialValue ?? '');
        const handleSave = React.useCallback(() => {
            onChange(title, value);
        }, [value, onChange, title]);
        return (
            <StyledBox>
                <Grid container spacing={3}>
                    <Grid size={12}>
                        <Typography variant="h6" className={classes.title} align="center">
                            {title}
                        </Typography>
                    </Grid>
                    <Grid size={12}>
                        <TextField
                            autoFocus
                            value={value}
                            onChange={handleChange}
                            label={description}
                            fullWidth
                            color="secondary"
                        />
                    </Grid>
                    <Grid size={12}>
                        <Button variant="contained" color="primary" onClick={handleSave} fullWidth>
                            {t('BASKET_ORDER_NOTES_SAVE')}
                        </Button>
                    </Grid>
                </Grid>
            </StyledBox>
        );
    };
